<script setup lang="ts">
import { useFlash } from '@/composables/useFlash'

useFlash()
</script>

<template>
  <UApp :toaster="{ position: 'bottom-right' }">
    <slot />
  </UApp>
</template>
